module.exports = __webpack_public_path__ + "img/features_img_finansial.eec43bfd.png";